import TableTemplate from "../../TableTemplate/tableTemplate";
import { IGroupTableReport } from "../../../Interfaces/optionDomain";
import { getGroupTable } from "../../../Requests/optionDomain";
import { CommonTableUI } from "../../TableTemplate/common";
import { useAppSelector } from "../../../App/hooks";
import { Additional } from "./Additional";

const GroupTable = () => {
  const refreshFlag = useAppSelector(
    (store) => store.optionDomain.groupTableFlag
  );

  return (
    <TableTemplate<any, IGroupTableReport>
      TableUI={({ reports, onAction, sortingType, setSortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          sortingType={sortingType}
          setSortingType={setSortingType}
          refreshFlag={refreshFlag}
          AdditionalBody={Additional}
        />
      )}
      getDataTable={getGroupTable}
      withSort
    />
  );
};

export default GroupTable;
